/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../App-switcherApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseAppPickerGetApplicationsV2Response,
  getCoinbaseAppPickerGetApplicationsV2ResponseErrors,
} from '../../types/coinbase/app_picker/CoinbaseAppPickerGetApplicationsV2Response';

export type ApplicationsV2Args = {
  clientOptions?: {
    /**
     * project_id is the UUID that identifies a project.
     */
    projectId?: string;

    /**
     * No description provided
     */
    locale?: string;

    /**
     * No description provided
     */
    action?: string;

    /**
     * No description provided
     */
    uiVersion?: string;
  };
};

export type ApplicationsV2Result = CoinbaseAppPickerGetApplicationsV2Response;

const validateApplicationsV2Result = (value: unknown) => {
  const errors = getCoinbaseAppPickerGetApplicationsV2ResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ApplicationsV2Result data does not match contract.`,
      errors,
    );
  }
};

export const getApplicationsV2Url = (
  params: ApplicationsV2Args,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.clientOptions?.projectId !== null && params.clientOptions?.projectId !== undefined) {
    const val = params.clientOptions?.projectId;
    searchParams.append('client_options.project_id', `${val}`);
  }

  if (params.clientOptions?.locale !== null && params.clientOptions?.locale !== undefined) {
    const val = params.clientOptions?.locale;
    searchParams.append('client_options.locale', `${val}`);
  }

  if (params.clientOptions?.action !== null && params.clientOptions?.action !== undefined) {
    const val = params.clientOptions?.action;
    searchParams.append('client_options.action', `${val}`);
  }

  if (params.clientOptions?.uiVersion !== null && params.clientOptions?.uiVersion !== undefined) {
    const val = params.clientOptions?.uiVersion;
    searchParams.append('client_options.ui_version', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/coinbase.app_picker.AppPickerService/GetApplicationsV2${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ApplicationsV2
 * @Url /coinbase.app_picker.AppPickerService/GetApplicationsV2
 * @Auth Required
 */

export function useGetApplicationsV2(
  params: ApplicationsV2Args,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ApplicationsV2Result | undefined;

export function useGetApplicationsV2(
  params: ApplicationsV2Args,
  options?: FetchOptions,
): ApplicationsV2Result;

export function useGetApplicationsV2(
  params: ApplicationsV2Args,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getApplicationsV2Url(params, options);
  const data = useFetch<ApplicationsV2Result>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateApplicationsV2Result(data);
  }

  return data;
}

/**
 * Access ApplicationsV2 fetch callback
 */
export const useGetApplicationsV2Callback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: ApplicationsV2Args, additionalHeaders?: Record<string, string>) => {
      const url = getApplicationsV2Url(params);
      const resource = getResource<ApplicationsV2Result>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateApplicationsV2Result(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ApplicationsV2 without throwing to suspense
 * @Url /coinbase.app_picker.AppPickerService/GetApplicationsV2
 * @Auth Required
 */
export const useRefreshApplicationsV2 = (
  params: ApplicationsV2Args,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getApplicationsV2Url(params);

  const { fetch } = useFetchableResource<ApplicationsV2Result>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ApplicationsV2 from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /coinbase.app_picker.AppPickerService/GetApplicationsV2
 */
export const useClearApplicationsV2 = (params: ApplicationsV2Args) => {
  const url = getApplicationsV2Url(params);

  const { clear } = useFetchableResource<ApplicationsV2Result>(url);

  return clear;
};

export const useWithOptimisticApplicationsV2Updates = (params: ApplicationsV2Args) => {
  const url = getApplicationsV2Url(params);

  const { optimisticUpdate } = useFetchableResource<ApplicationsV2Result>(url);

  return optimisticUpdate;
};
